import { capitalizeAll } from '@btime/helpers'
import { compose, prop, propOr } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../../components/presentation/Text'
import Panel from '../../../../components/structure/Panel'
import PlacePresenter from '../../../../containers/places/PlacePresenter'

const PlaceDetailsPanel = ({ place }) => {
  // TODO: Move to common
  const { t } = useTranslation()

  if (!place || !place.id) return false

  const name = compose(capitalizeAll, propOr('', 'name'))(place)
  const resume = compose(capitalizeAll, propOr('', 'resume'))(place)
  const type = compose(capitalizeAll, prop('type'))(place)

  return (
    <Panel lineBorder mediumPadding>
      <Title size="h6">{t('place', { context: type })}</Title>
      <PlacePresenter place={place} />
    </Panel>
  )
}

export default PlaceDetailsPanel
